export const updateThumbnailPath = image => {
  // if (window.p_thumb_v2) {
    image.thumbnailPath = `${image.path}/thumb/${image.thumb_name}`;
    image.smallThumbnailPath = `${image.path}/thumb/thumb_sm_${image.thumb_name.substring(6)}`;
    return image;
  // }

  // image.thumbnailPath = `${image.path}/${image.thumb_name}`
  // image.smallThumbnailPath = `${image.path}/${image.thumb_name}`
  // return image;
}
